import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper'

const resource = '/xdent/companies';

export default {
    getAllCompanies: token => {
        return req(token).then(token => {
            return Request.get(`${resource}/getallcompaniesbyuser`, token);
        })
    },
    getCompanyById: (id, token) => {
        return req(token).then(token => {
            return Request.get(`${resource}/${id}`, token);
        })
    },
}